import { Button, Space, Tooltip } from "antd";
import { useComputer } from "hook/base/computer/useComputerAction";
import { MdOutlineTrackChanges } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { LuTrash2 } from "react-icons/lu";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const TableAction = ({ data }) => {
  // -------------------------- VAR -----------------------------
  const { handleConfirmMachine } = useComputer();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderUpdateButton = () => {
    return (
      <Tooltip title="Update Status">
        <Button
          onClick={() =>
            handleConfirmMachine({ id: data.id, key: "update-status" })
          }
          shape="circle"
          size="small"
          icon={
            <span className="anticon">
              <MdOutlineTrackChanges />
            </span>
          }
        />
      </Tooltip>
    );
  };

  const renderForceClose = () => {
    return (
      <Tooltip title="Force Close">
        <Button
          onClick={() =>
            handleConfirmMachine({ id: data.id, key: "force-close" })
          }
          shape="circle"
          size="small"
          icon={
            <span className="anticon">
              <IoMdClose />
            </span>
          }
        />
      </Tooltip>
    );
  };

  const renderDeleteMachine = () => {
    return (
      <Tooltip title="Delete Machine">
        <Button
          onClick={() =>
            handleConfirmMachine({ id: data.id, key: "delete-machine" })
          }
          shape="circle"
          size="small"
          danger
          icon={
            <span className="anticon">
              <LuTrash2 />
            </span>
          }
        />
      </Tooltip>
    );
  };
  // -------------------------- MAIN ----------------------------
  return (
    <Space>
      {renderUpdateButton()}
      {renderForceClose()}
      {renderDeleteMachine()}
    </Space>
  );
};
export default TableAction;
